
    import {Component, Prop, Vue} from 'vue-property-decorator';

    @Component({})
    export default class DownloadExample extends Vue {
        @Prop() private name!: string;
        get url() {
            return `https://github.com/mnapoli/serverless-visually-explained/tree/master/examples/${this.name}`;
        }
    }
